import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type ScheduleBoardEmployeeViewModel from 'ab-viewModels/scheduleBoardEmployee.viewModel';

import { isAllowed } from '@acceligentllc/shared/utils/auth';

import type { ExtendedColorValue } from '@acceligentllc/shared/enums/color';

import type { RootState } from 'af-reducers';

import * as ColorUtils from 'af-utils/color.util';

import PagePermissions from 'ab-enums/pagePermissions.enum';

import EmployeeAdditionalInfo from './EmployeeAdditionalInfo';
import { getDisplayData } from './helpers';
import PerDiemIndicator from './PerDiemIndicator';
import styles from './styles.module.scss';

interface OwnProps {
	employee: ScheduleBoardEmployeeViewModel;
	officeColor: ExtendedColorValue;
	isDragAndDropDisabled: boolean;
	hasPermissionsToEditScheduleBoard: boolean;
	isPerDiem?: boolean;
	isAllowedToManagePerDiems?: boolean;
	isCrewLead?: boolean;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const DraggableItemBody: React.FC<Props> = (props: Props) => {
	const {
		employee,
		officeColor,
		isPerDiem,
		isAllowedToManagePerDiems,
		isCrewLead,
		canViewForeman,
	} = props;
	const { firstName, lastName } = getDisplayData(employee);

	return (
		<>
			{canViewForeman && isCrewLead && <div className={styles['crew-lead-indicator']} />}

			<span className={`sb-resource-item__full-name ${ColorUtils.getColorTextClass(officeColor, true)}`}>
				{firstName} <span className="sb-resource-item__lastName">{lastName}</span>
			</span>

			<EmployeeAdditionalInfo employee={employee} />
			{isAllowedToManagePerDiems && <PerDiemIndicator isPerDiem={!!isPerDiem} />}
		</>
	);
};

function mapStateToProps(state: RootState) {
	const { user: { companyData, userData } } = state;

	if (!userData || !companyData) {
		throw new Error('User not logged in');
	}

	const { isCompanyAdmin, permissions } = companyData;
	const { role } = userData;

	const canViewForeman = isAllowed(
		PagePermissions.COMPANY.FOREMAN.VIEW,
		permissions,
		isCompanyAdmin,
		role
	);

	return {
		canViewForeman,
	};
}

const connector = connect(mapStateToProps);

export default connector(DraggableItemBody);
